import React, { createContext, useContext, useState } from "react";

const LicenseContext = createContext();

export const LicenseProvider = ({ children }) => {
  const [licenseInfo, setLicenseInfo] = useState(null);

  return (
    <LicenseContext.Provider value={{ licenseInfo, setLicenseInfo }}>
      {children}
    </LicenseContext.Provider>
  );
};

export const useLicense = () => useContext(LicenseContext);
